import type { ReactElement } from "react";

import { Tooltip } from "antd";

/** Icon-rail tooltips (replaces native `title` on collapsed desktop sidebar). */
export function SidebarIconTooltip({
  label,
  enabled,
  children,
}: {
  label: string;
  enabled: boolean;
  children: ReactElement;
}) {
  if (!enabled) return children;

  return (
    <Tooltip
      title={label}
      placement="right"
      mouseEnterDelay={0.12}
      destroyTooltipOnHide
      getPopupContainer={() => document.body}
    >
      <span className="flex w-full min-w-0">{children}</span>
    </Tooltip>
  );
}
